import { MessageCircle } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { localText } from '@/lib/localText';
import { trackPublicClick } from '@/lib/publicTracking';

const WHATSAPP_NUMBER = '15615621840';

const WhatsAppButton = () => {
  const { lang } = useLanguage();
  const label = localText(
    lang,
    'Chat with us on WhatsApp',
    'تواصل معنا عبر واتساب',
    'Discutez avec nous sur WhatsApp'
  );
  const href = `https://wa.me/${WHATSAPP_NUMBER}`;

  const handleClick = () => {
    trackPublicClick({
      action: 'whatsapp_click',
      language: lang,
      source: 'floating_button',
      extra: { number: WHATSAPP_NUMBER },
    });
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      aria-label={label}
      title={label}
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white rounded-full shadow-[0_8px_30px_-5px_hsl(0_0%_0%/0.4)] transition-all duration-300 hover:scale-105 p-4"
    >
      <MessageCircle className="h-6 w-6 fill-white" strokeWidth={1.5} />
      <span className="hidden sm:inline-block max-w-0 group-hover:max-w-[220px] overflow-hidden whitespace-nowrap transition-all duration-300 text-sm font-semibold tracking-wide">
        {label}
      </span>
    </a>
  );
};

export default WhatsAppButton;
